// tslint:disable:no-empty
export class StateMockService {
    public static $name = '$state';

    public $get() {
    }

    public state(name, config) {
    }

    public transitionTo() {
    }

    public go() {
    }
}
